import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

import InputBorderNone from 'components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import guarantorYellow from 'assets/images/guarantor-yellow.svg';
import TagOwnerState from './TagOwnerState';

interface CardOwnershipEditProps {
  ownership?: any;
  disabledNames?: boolean;
  onSaveDraft: (values: any) => void;
  handlerClose: Function;
  totalPercentage: number;
  tagStateGuarantor?: 'incomplete';
  setNewPercentageLiveEdit?: any;
}

const CardOwnershipEdit = ({
  ownership = {},
  disabledNames,
  onSaveDraft,
  handlerClose,
  totalPercentage,
  tagStateGuarantor,
  setNewPercentageLiveEdit
}: CardOwnershipEditProps) => {
  const [form] = Form.useForm();
  
  const [ownershipPercentage, setOwnershipPercentage] = useState<number>((100 - totalPercentage) < 0 ? 0 : (100 - totalPercentage));

  useEffect(() => {
    setNewPercentageLiveEdit({ value: ownershipPercentage });
  }, [ownershipPercentage]);

  useEffect(() => form.resetFields(), [ownership]);

  const deleteOwnership = () => handlerClose();

  const onBlurCreateOwner = () => {
    const values = form.getFieldsValue();

    if(values.name?.length > 0 && values.lastname?.length > 0 && values.ownership) {
      onSaveDraft(values)
    }
  }

  return (
    <Form
      form={form}
      name="edit"
      autoComplete="off"
      className="card-ownership-edit"
      requiredMark="optional"
      colon={false}
      initialValues={ownership}
      onFinish={onSaveDraft}
    >
      <CloseCircleFilled
        className="icon-delete"
        onClick={deleteOwnership}
      />

      <Form.Item
        label="First name"
        name="name"
        className="name"
        rules={[{ required: true, message: '' }]}
      >
        <InputBorderNone
          placeholder="Nicolas"
          height={20}
          className="bold-lith"
          disabled={disabledNames}
          onBlur={onBlurCreateOwner}
        />
      </Form.Item>
      <Form.Item
        label="Last name"
        name="lastname"
        className="lastname"
        rules={[{ required: true, message: '' }]}
      >
        <InputBorderNone
          placeholder="Ortiz"
          height={20}
          className="bold-lith"
          disabled={disabledNames}
          onBlur={onBlurCreateOwner}
        />
      </Form.Item>

      <Form.Item
        label="Ownership"
        name="ownership"
        className="ownership"
        rules={[{ required: true, message: '' }]}
        initialValue={(100 - totalPercentage) < 0 ? 0 : (100 - totalPercentage)}
      >
        <InputBorderNone
          type="number"
          placeholder="20"
          height={20}
          max={100}
          min={1}
          className="bold-lith"
          suffix="%"
          onChange={(v: number) => setOwnershipPercentage(v)}
          onBlur={onBlurCreateOwner}
          deletefull={true}
        />
      </Form.Item>
      {ownershipPercentage !== undefined && ownershipPercentage >= 20 &&
        <span className="body-regular body-regular-w5 guarantor tag-guarantor">
          <img src={guarantorYellow} className="lienzo" alt="lienzoSvg" />{' '}
          Guarantor
        </span>
      }

      <TagOwnerState
        className="tag-owner-state"
        state={ownershipPercentage && ownershipPercentage >= 20 ? 
          (tagStateGuarantor? tagStateGuarantor: 'next-step') : 'no-guarantor'
        }
      />
    </Form>
  );
};
export default CardOwnershipEdit;
